import React from 'react';
import { useNavigate } from "react-router-dom";

import '../CustomCSS/RebookThenModal.css';

const RebookThenModal = ({ 
  onClose, 
  onNewBooking, 
  onHome, 
  onMyBookings 
}) => {
    const navigate = useNavigate();
    
    const handleHome = () => {
        onClose(); // Close the modal
        navigate("/");
    };

    const handleMyBookings = () => {
        onClose(); // Close the modal
        navigate("/my_bookings");
    };

    return (
        <div className="rebook-then-modal-container show">
            <div className="rebook-then-modal-overlay" onClick={onClose}></div>
            <div className="rebook-then-modal-dialog">
                <div className="rebook-then-modal-content">
                    <div className="rebook-then-modal-header">
                        <h5 className="rebook-then-modal-title">Ongoing Booking Alert</h5>
                        <button 
                            type="button" 
                            className="rebook-then-btn-close" 
                            onClick={onClose}
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="rebook-then-modal-body">
                        <p>You currently have an ongoing booking that needs to be closed before you can place a new booking.</p>
                        <div className="alert alert-warning mt-3" role="alert">
                            Please review and close your existing booking to proceed.
                        </div>
                    </div>
                    <div className="rebook-then-modal-footer">
                        <button 
                            type="button" 
                            className="btn btn-secondary rebook-homebtn" 
                            onClick={handleHome}
                        >
                            Home
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-primary" 
                            onClick={handleMyBookings}
                        >
                            My Bookings
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default RebookThenModal;